<app-price-editor class="change-price-form"
                  [price]="price"
                  [priceAttribute]="priceAttribute"
                  (formReady)="onFormReady($event)" />

<mat-divider />

<div class="change-price-actions" mat-dialog-actions>
  <app-button (click)="onCancel()" btnType="cancel">
    {{ 'cancel' | translate }}
  </app-button>
  <app-button (click)="onSave()">
    {{ 'save' | translate }}
  </app-button>
</div>
